<template>
  <bm-dialog :label="$m.auth_current_sessions" :closeable="false" :width="800">
    <p v-html="logoffPromptText" />
    <bm-grid
      :grid-configuration="gridConfiguration"
      :items="items"
      :grid-state="gridState"
    >
      <template #no-data>
        <span>{{ $m.users_no_active_sessions }}</span>
      </template>
    </bm-grid>

    <template #controls>
      <v-container fluid pa-0>
        <v-row no-gutters>
          <v-col cols="12" sm="6">
            <bm-btn
              button-type="secondary"
              :t="$m.keys.auth_log_out"
              :block="!isDesktopView"
              @click="signOut"
            ></bm-btn>
          </v-col>
          <v-col cols="12" sm="6" class="text-right">
            <bm-btn
              btn-class="mr-2"
              button-type="secondary"
              :t="$m.keys.refresh"
              :block="!isDesktopView"
              @click="refresh"
            ></bm-btn>
            <bm-btn
              :btn-class="!isDesktopView ? 'mt-3' : ''"
              button-type="primary"
              :disabled="tenantMaxSessions <= items.length"
              :block="!isDesktopView"
              @click="performLicenseCheck"
              >{{ $m.continue }}</bm-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </template>
  </bm-dialog>
</template>

<script setup lang="ts">
import BmBtn from "@/components/controls/input/BmBtn.vue";
import BmDialog from "@/components/dialogs/BmDialog.vue";
import BmGrid from "@/components/controls/grid/BmGrid.vue";
import type { DialogEvents } from "@/components/mixins/dialogs";
import { useReactiveDialogScriptSetup } from "@/components/mixins/dialogs";
import { useCurrentSessions } from "@/components/pages/composables/currentSessions";

interface ForceLogoffDialogEvents extends DialogEvents {}

const emit = defineEmits<ForceLogoffDialogEvents>();

const {
  logoffPromptText,
  gridConfiguration,
  items,
  gridState,
  isDesktopView,
  signOut,
  refresh,
  tenantMaxSessions,
  performLicenseCheck,
} = useCurrentSessions();

useReactiveDialogScriptSetup(emit);
</script>
